import CustomTitle from '../CustomElements/CustomTitle';
import CustomContainer from '../CustomElements/CustomContainer';
import ConfirmationPage from '../CustomElements/ConfirmationPage';

function BrigadeExceptionDevise({ exceptionDevice, closeModal, handlerConfirm, t }) {
  const baseText = t?.excludeDeviceConfirmText
    ?.replace('{deviceType}', String(exceptionDevice?.type ?? ''))
    ?.replace('{deviceId}', String(exceptionDevice?.id ?? ''));

  const needWarning =
    exceptionDevice?.online === false &&
    typeof exceptionDevice?.id === 'number' &&
    exceptionDevice.id >= 300000 &&
    exceptionDevice.id <= 399999;

  const warning = t?.kuobzNotConnectedMeshNotReset || '';

  // если нужно предупреждение — собираем JSX, иначе оставляем строку
  const confirmContent = needWarning ? (
    <>
      <span>{baseText}</span>
      <br />
      <br />
      <br />
      <span className="confirm-warning">{warning}</span>
      <br />
      <br />
    </>
  ) : (
    baseText
  );

  return (
    <CustomContainer>
      <CustomTitle titleText={t?.excludeDeviceTitle} />
      <ConfirmationPage
        confirmText={confirmContent}
        confirmButtonText={t.excludeDeviceConfirmButton}
        cancelButtonText={t.excludeDeviceCancelButton}
        onConfirm={() => handlerConfirm(exceptionDevice.id)}
        onCancel={closeModal}
      />
    </CustomContainer>
  );
}

export default BrigadeExceptionDevise;
